module.exports = __webpack_public_path__ + "static/media/pdf_image.ae09dbbb.png";